export const TIMEZONE_STORAGE_KEY = "timezone";
export const DEFAULT_TIMEZONE = "Europe/Warsaw";

export const APP_TIMEZONES = [
    { id: "Europe/London", labelKey: "timezone.london" },
    { id: "Europe/Berlin", labelKey: "timezone.berlin" },
    { id: "Europe/Warsaw", labelKey: "timezone.warsaw" },
    { id: "Europe/Helsinki", labelKey: "timezone.helsinki" },
];

const TIMEZONE_IDS = new Set(APP_TIMEZONES.map((zone) => zone.id));

export const isAppTimeZone = (value) => TIMEZONE_IDS.has(value);

export function getAppTimeZone() {
    if (typeof window === "undefined") {
        return DEFAULT_TIMEZONE;
    }
    try {
        const stored = window.localStorage.getItem(TIMEZONE_STORAGE_KEY);
        return isAppTimeZone(stored) ? stored : DEFAULT_TIMEZONE;
    } catch {
        return DEFAULT_TIMEZONE;
    }
}

export function setAppTimeZone(timeZone) {
    const next = isAppTimeZone(timeZone) ? timeZone : DEFAULT_TIMEZONE;
    if (typeof window !== "undefined") {
        window.localStorage.setItem(TIMEZONE_STORAGE_KEY, next);
    }
    return next;
}

export function timeZoneOffsetMinutes(date, timeZone) {
    const parts = new Intl.DateTimeFormat("en-US", {
        timeZone,
        hourCycle: "h23",
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
    }).formatToParts(date);
    const value = (type) => parts.find((part) => part.type === type)?.value ?? "0";
    const hour = Number(value("hour")) === 24 ? 0 : Number(value("hour"));
    const asUtc = Date.UTC(
        Number(value("year")),
        Number(value("month")) - 1,
        Number(value("day")),
        hour,
        Number(value("minute")),
        Number(value("second")),
    );
    return Math.round((asUtc - date.getTime()) / 60000);
}

export function formatOffsetMinutes(minutes) {
    const sign = minutes >= 0 ? "+" : "-";
    const abs = Math.abs(minutes);
    const hours = String(Math.floor(abs / 60)).padStart(2, "0");
    const mins = String(abs % 60).padStart(2, "0");
    return `${sign}${hours}:${mins}`;
}

/** Label such as `UTC+2` for the offset in effect at `date`. */
export function utcOffsetLabel(timeZone, date = new Date()) {
    const minutes = timeZoneOffsetMinutes(date, timeZone);
    const sign = minutes >= 0 ? "+" : "-";
    const abs = Math.abs(minutes);
    const hours = Math.floor(abs / 60);
    const mins = abs % 60;
    if (mins === 0) {
        return `UTC${sign}${hours}`;
    }
    return `UTC${sign}${hours}:${String(mins).padStart(2, "0")}`;
}
